(function () {
  'use strict';

  var motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Scroll-reveal (CSS-driven) ─────────────────────────── */
  function initScrollReveal() {
    var els = document.querySelectorAll('.dot-sr');
    if (!els.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('dot-sr--visible');
        observer.unobserve(e.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -32px 0px' });
    els.forEach(function (el) { observer.observe(el); });
  }

/* ── Hero entrance stagger (anime.js) ───────────────────── */
  function heroEntrance() {
    if (typeof anime === 'undefined') return;
    var hero = document.querySelector('[data-hero-dot]');
    if (!hero) return;
    var targets = hero.querySelectorAll(
      '.hero-lovable__title, .hero-lovable__title2, .hero-lovable__subtitle, .hero-lovable__buttons'
    );
    if (!targets.length) return;
    anime({
      targets: Array.from(targets),
      opacity: [0, 1],
      translateY: [20, 0],
      duration: 280,
      delay: anime.stagger(90),
      easing: 'easeOutQuad'
    });
  }

  /* ── Stagger section children (anime.js) ────────────────── */
  function initStagger() {
    if (typeof anime === 'undefined') return;
    var sections = document.querySelectorAll('[data-stagger-section]');
    if (!sections.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var items = e.target.querySelectorAll('[data-stagger]');
        if (items.length) {
          anime({
            targets: Array.from(items),
            opacity: [0, 1],
            translateY: [18, 0],
            duration: 240,
            delay: anime.stagger(65),
            easing: 'easeOutQuad'
          });
        }
        observer.unobserve(e.target);
      });
    }, { threshold: 0.08 });
    sections.forEach(function (s) { observer.observe(s); });
  }

  /* ── How-it-works step stagger ──────────────────────────── */
  function initHIWStagger() {
    if (typeof anime === 'undefined') return;
    var grid = document.querySelector('.hiw__grid[data-stagger-section]');
    if (!grid) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var steps = e.target.querySelectorAll('.hiw__step');
        anime({
          targets: Array.from(steps),
          opacity: [0, 1],
          translateY: [22, 0],
          duration: 260,
          delay: anime.stagger(80),
          easing: 'easeOutQuad'
        });
        observer.unobserve(e.target);
      });
    }, { threshold: 0.1 });
    observer.observe(grid);
  }

  /* ── Run ────────────────────────────────────────────────── */
  function run() {
    initScrollReveal();
    if (motionOk) {
      heroEntrance();
      initStagger();
      initHIWStagger();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
